/* eslint-disable ember/no-mixins */
import Controller from '@ember/controller';
import { action, computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import { tracked } from '@glimmer/tracking';
import BatchReportMixin from 'linced-app/mixins/finance/batch-report';

export default class LedgerItemController extends Controller.extend(
  BatchReportMixin,
) {
  // The two titles are editable: the report template renders each in a
  // PaperInput.
  @tracked _summaryTitle = null;
  @tracked _reportTitle = null;

  @computed('model.ledgerItem.name', 'from', 'to', '_summaryTitle')
  get summaryTitle() {
    if (this._summaryTitle !== null) {
      return this._summaryTitle;
    }
    return `Batch report: ${this.model.ledgerItem.name} (${this.from} - ${this.to}) - Ledger Summary`;
  }

  @action
  setSummaryTitle(value) {
    this._summaryTitle = value;
  }

  @computed('model.ledgerItem.name', 'from', 'to', '_reportTitle')
  get reportTitle() {
    if (this._reportTitle !== null) {
      return this._reportTitle;
    }
    return `Batch report: ${this.model.ledgerItem.name} (${this.from} - ${this.to})`;
  }

  @action
  setReportTitle(value) {
    this._reportTitle = value;
  }

  @alias('model.ledgerItem.ledger')
  ledger;

  @alias('model.ledgerItem.isTaxable')
  isTaxable;
}
